import React from 'react';
import Aux from '../../hoc/Aux';
import * as actions from '../../store/actions/index';
import { currentLang } from '../../store/actions/support';
import { format } from 'date-fns'
import ReadSingleDownloadButton from './ReadSingleDownloadButton.js'

const DocumentationFileTable = (props) => {

  const headline = props.headline;
  const documents = (Array.isArray(props.files))? props.files : [];
  const fileInfos = props.fileInfos;
  const filesNotRead = fileInfos.map( x => x['documentation_file'].id)

  const checkFile = (file) => { return filesNotRead.find( x => x === file.id) !== undefined }
  const getDocumentationFileUserInfo = (fileId) => { return fileInfos.find( x => x['documentation_file'].id === fileId).id}

  const downloadFile = (filename, id) => actions.downloadDocumentationPdf(filename, id);

  if (documents.length > 0 ) {
    return (
       <Aux>
        <table className="table table-striped downloads">
          <thead>
            <tr>
              <th scope="col" style={{fontWeight: "800"}}>{ headline }</th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            { documents.map( doc =>
              <tr className={ (checkFile(doc))? 'updated_file' : ''}>
              <th onClick={downloadFile(doc.filename, doc.id)} className="filename" scope="row">{ doc.text[currentLang()]}</th>
              <td>{ format(new Date(doc.update_at), 'dd.MM.yyyy')  }</td>
              <td style={{textAlign: "right"}}>{ (checkFile(doc))? <ReadSingleDownloadButton documentationFileUserInfoId={getDocumentationFileUserInfo(doc.id)}/> : ''}</td>
              </tr>
            )}
          </tbody>
        </table>
      </Aux>
    )}
   else { return null; }
}



export default DocumentationFileTable;



// WEBPACK FOOTER //
// ./src/components/Documentations/DocumentationFileTable.js